<template>
    <div class="scrollbar-wrapper-horizontal">
        <div @click="calculatePosition" :id="barId" class="scrollbar">
            <div @mousedown="bindMouseDown" :id="sliderId" class="scrollbar-slider"></div>
        </div>
    </div>
</template>

<script>
    import scrollBus from './ScrollBus';

    export default {
        data() {
            return{
                barId: '',
                sliderId: '',
            };
        },

         mounted: function () {

             document.onmouseup = this.clear

             scrollBus.$on('scrollUpdateHorizontal', (msg) => {

            
    
                let startLeft = msg * this.barWidth / 100    
                if( document.getElementById(this.sliderId)){       
                    document.getElementById(this.sliderId).style.left = startLeft+'px';

                }
                
            }); 
         },
        methods: {
            bindMouseDown() {
                console.log("click")
                document.onmousemove = this.calculatePosition;
            },
            clear() {
                console.log("clear")
                document.onmousemove = null;
            },
            calculatePosition(event) {
                var mousePos = event.clientX;
                var sliderOffset = this.calculateSliderOffset();

                // Making the lowest point on the bar zero
                var absolutePosOnBar = mousePos - this.barOffset;
                
                // Half of the slider is insignificant for calculating
                // the length travelled by it. Hence - (this.sliderWidth / 2)
                let posOnBar = absolutePosOnBar - (this.sliderWidth / 2);

                // The length of the bar actually used for calculation purposes
                var clickableAreaLength = this.barWidth - this.sliderWidth;

                // The maximum distance on the bar
                if (posOnBar > clickableAreaLength) {
                    posOnBar = clickableAreaLength;
                }
 
                // If the mouse curser is left or right of the scrollbar
                // (i.e. not on the scrollbar)
                // stop doing scrolling
                if ((absolutePosOnBar < 0) || (posOnBar > this.barWidth + this.barOffset))  {
                    this.clear();
                }

                var slider = document.getElementById(this.sliderId);

                // The distance travelled as percentage
                // to be sent to the gallery component
                let percToSend = (posOnBar * 100 ) / clickableAreaLength;

                let displayPerc = posOnBar;

                // This is done to prevent the slider move behind
                // its "point 0"
                if (0 > displayPerc) {
                    displayPerc = 0;
                }

                scrollBus.$emit('changeHorizontal', (percToSend));
                slider.style.left = displayPerc + 'px';

            },
            elementPos(el) {
                var rect = el.getBoundingClientRect()
                var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
                return rect.left + scrollLeft;
            },
            calculateSliderOffset() {
                var slider = document.getElementById(this.sliderId);
                //var rect = slider.getBoundingClientRect();
                //return rect.left;
                return this.elementPos(slider);
            }
        },
        computed: {
            barWidth() {
                var bar = document.getElementById(this.barId);
                return bar.offsetWidth;
            },
            sliderWidth() {
                var slider = document.getElementById(this.sliderId);
                return slider.offsetWidth;
            },
            barOffset() {
                var bar = document.getElementById(this.barId);
                return this.elementPos(bar);
            },
        },
        created() {
            this.barId = Math.random().toString(36).substring(7);
            this.sliderId = Math.random().toString(36).substring(7);
        },
    };
</script>





// WEBPACK FOOTER //
// ScrollBarHorizontal.vue?942ccba6